import { HeroSection } from '@/components/home/HeroSection'
import { MarqueeStrip } from '@/components/home/MarqueeStrip'
import { IntroSection } from '@/components/home/IntroSection'
import { ServicesSection } from '@/components/home/ServicesSection'
import { PillarsSection } from '@/components/home/PillarsSection'
import { TestimonialsSection } from '@/components/home/TestimonialsSection'
import { BookTeaser } from '@/components/home/BookTeaser'
import { CtaSection } from '@/components/home/CtaSection'

export const HomePage = () => (
  <>
    <HeroSection />
    <MarqueeStrip />
    <IntroSection />
    <ServicesSection />
    <TestimonialsSection />
    <PillarsSection />
    <BookTeaser />
    <CtaSection />
  </>
)
